<div class="chat-panel" role="dialog" aria-label="Billie - Asistente Billcentrix">
  <!-- ─── Header ──────────────────────────────────────────────────── -->
  <header class="chat-header">
    <div class="header-left">
      <span class="header-icon">💬</span>
      <div class="header-info">
        <h3 class="header-title">Billie</h3>
        <span class="header-status" [class.loading]="uiState.isLoading">
          {{ uiState.isLoading ? 'Escribiendo...' : 'En línea' }}
        </span>
      </div>
    </div>
    <div class="header-actions">
      <button
        class="icon-btn"
        (click)="newConversation()"
        title="Nueva conversación"
        aria-label="Nueva conversación"
        type="button">
        🔄
      </button>
      <button
        class="icon-btn close-btn"
        (click)="close()"
        title="Cerrar chat"
        aria-label="Cerrar chat"
        type="button">
        ✕
      </button>
    </div>
  </header>

  <!-- ─── Messages ────────────────────────────────────────────────── -->
  <div class="chat-messages" #messagesContainer>
    <!-- Welcome message when empty -->
    @if (messages.length === 0 && !uiState.isLoading) {
      <div class="welcome">
        <div class="welcome-icon">🤖</div>
        <h4>¡Hola! Soy Billie</h4>
        <p>Tu asistente de Billcentrix. Puedo ayudarte con suscripciones, facturación, pagos y más. ¿En qué te ayudo?</p>
      </div>
    }

    <!-- Message list -->
    @for (msg of messages; track trackByMessageId($index, msg)) {
      <app-chat-message
        [message]="msg">
      </app-chat-message>
    }

    <!-- Typing indicator -->
    @if (uiState.isLoading) {
      <app-chat-typing-indicator></app-chat-typing-indicator>
    }
  </div>

  <!-- ─── Error banner ────────────────────────────────────────────── -->
  @if (uiState.error) {
    <div class="error-banner">
      <span class="error-text">⚠️ {{ uiState.error }}</span>
      <button class="error-dismiss" (click)="dismissError()" type="button" aria-label="Cerrar error">✕</button>
    </div>
  }

  <!-- ─── Footer / Input ──────────────────────────────────────────── -->
  <app-chat-input
    [disabled]="uiState.isLoading"
    (sent)="onSend($event)">
  </app-chat-input>
</div>
